<template>
  <div class="page-export-test">
    <div id="printContent">
      <header>
        <h3>{{ this.time }}{{ this.categoryObj.subjectName }}同步练习</h3>
        <div class="header-info">
          <h3>姓名:</h3>
          <h3>班级:</h3>
        </div>
      </header>
      <section>
        <!-- 题目内容 -->
        <div
          class="test-info"
          v-for="(qItem, index) in questionList"
          :key="index"
        >
        <!-- 非题冒题 -->
          <div v-if="qItem.question_title_uuid === ''">
            <p class="test-info__head">
            <span class="test-info__head__left"
              >{{ index + 1 }}、{{ qItem.question_type_name }}</span
            >
            <span class="test-info__head__right"
              >难度:{{ qItem.difficulty }}</span
            >
            </p>
            <div class="test-info__body">
              <div v-katexHtml="htmlDeCode(qItem.content.content)" />
              <div v-if="qItem.content.image.length">
                <img
                  v-for="(img, index) in qItem.content.image"
                  :key="index"
                  :src="img.source"
                />
              </div>
            </div>
            <!-- 选词填空 -->
              <div
                v-if="
                  qItem &&
                  qItem.question_type === 6 &&
                  qItem.show_type === '112'
                "
                class="test-info__answer"
              >
                <div v-for="(oitem, oindex) in qItem.choice_words" :key="oindex">
                  <p class="test-info__answer__item" v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
            <!-- 判断题 -->
            <div
            v-if="qItem.question_type === 3 && qItem.show_type  === '103'"
            class="test-info__answer"
          >
            <div
              v-for="(oitem, oindex) in Number(subjectId) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p class="test-info__answer__item">{{ oitem }}</p>
            </div>
          </div>
            <!-- 答题选项 -->
            <ul v-if="qItem.question_type !== 3" class="test-info__answer">
              <li
                v-for="(option, index) in qItem.options"
                :key="index"
                class="test-info__answer__item"
              >
                <span>{{ option.key }}.</span>
                <div
                  class="item"
                  v-if="option.content"
                  v-katexUbb="htmlDeCode(option.content)"
                />
                <span
                  v-else-if="isNumber(option.content)"
                  v-html="option.content"
                />
                <span v-else v-katex="htmlDeCode(option.content)" />
              </li>
            </ul>
          </div>
          <!-- 题冒题 -->
          <div v-else>
            <p
              v-if="qItem.question_list !== null"
              v-katexHtml="htmlDeCode(qItem.content.content)"></p>
            <p v-else v-katexHtml="htmlDeCode(titleContent(qItem.title_question))"></p>
            <div v-if="qItem.content.image.length">
                <img
                  v-for="(img, index) in qItem.content.image"
                  :key="index"
                  :src="img.source"
                />
            </div>
            <div v-if="qItem.question_list === null">
              <div class="test-info__body">
              <span>{{ index + 1 }}、</span>
              <div style="display:inline-block;" v-katexHtml="htmlDeCode(qItem.content.content)" />
              <div v-if="qItem.content.image.length">
                <img
                  v-for="(img, index) in qItem.content.image"
                  :key="index"
                  :src="img.source"
                />
              </div>
            </div>
            </div>
            <div v-else v-for="(litem, lindex) in qItem.question_list" :key="lindex">
              <div class="test-info__body">
                <span class="test-info__head__left">
                  {{ lindex + 1 }}、
                </span>
              <div style="display:inline-block;" v-katexHtml="htmlDeCode(litem.content.content)">
              </div>
                <div v-if="litem.content.image.length">
                  <img
                    v-for="(img, index) in litem.content.image"
                    :key="index"
                    :src="img.source"
                  />
                </div>
              </div>
              <!-- 选词填空 -->
              <div
                v-if="
                  litem &&
                  litem.question_type === 6 &&
                  litem.show_type === '112'
                "
                class="test-info__answer"
              >
                <div v-for="(oitem, oindex) in litem.choice_words" :key="oindex">
                  <p class="test-info__answer__item" v-katexUbb="htmlDeCode(oitem.content)"></p>
                </div>
              </div>
            <!-- 判断题 -->
            <div
            v-if="litem.question_type === 3 && litem.show_type  === '103'"
            class="test-info__answer"
          >
            <div
              v-for="(oitem, oindex) in Number(subjectId) === 1
                ? enText
                : cnText"
              :key="oindex"
            >
              <p class="test-info__answer__item">{{ oitem }}</p>
            </div>
          </div>
              <!-- 答题选项 -->
              <ul v-if="litem.question_type !== 3" class="test-info__answer">
                <li
                  v-for="(option, index) in litem.options"
                  :key="index"
                  class="test-info__answer__item"
                >
                  <span>{{ option.key }}.</span>
                  <div
                    class="item"
                    v-if="option.content"
                    v-katexUbb="htmlDeCode(option.content)"
                  />
                  <span
                    v-else-if="isNumber(option.content)"
                    v-html="option.content"
                  />
                  <span v-else v-katex="htmlDeCode(option.content)" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer>
      <div class="stamp" @click="print">打印</div>
      <div class="go-top" @click="goToTop">
        <i class="el-icon-top" />回到顶部
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { htmlDecodeByRegExp } from '@/utils';
import { getQuestionInfoByIds } from '@/api/pt';
import _ from 'lodash';

export default {
  name: 'ExportQuestion',
  data() {
    return {
      time: '',
      cnText: ['正确', '错误'],
      enText: ['True', 'False'],
      subjectId: this.$route.query.subjectId,
      showButton: false,
      questionList: [], // 题目列表
      qOptions: [], // 选项列表
    };
  },
  computed: {
    ...mapGetters([
      'questionsBasket',
      'categoryObj',
    ]),
    questionName() {
      const arr = ['未定义', '单选题', '多选题', '填空题'];
      return (num) => arr[num];
    },
  },
  // async created() {
  //   await this.getContentDetail();
  // },
  methods: {
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    print() {
      window.print();
    },
    goToTop() {
      window.scroll(0, 0);
    },
    titleContent(title) {
      const content = _.get(title.content, 'content');
      return content;
    },
  },
  async mounted() {
    const myDate = new Date();
    let tMonth = myDate.getMonth() + 1;
    let tDay = myDate.getDate();
    tMonth = tMonth < 10 ? `0${tMonth}` : tMonth;
    tDay = tDay < 10 ? `0${tDay}` : tDay;
    this.time = `${tMonth}${tDay}`;
    const { questionsBasket } = this.$store.state;
    const questionIds = questionsBasket.map(
      (item) => (Number(item.question_title_uuid) === 1 ? item.question_uuid
        : item.question_title_uuid || item.question_uuid),
    );
    const content = Array.from(new Set(questionIds)).join(',');
    console.log(content);
    const res = await getQuestionInfoByIds({
      question_ids: content,
    });
    this.questionList = Object.values(res.data);
    console.log(Object.values(res.data));
  },
};
</script>

<style lang="scss" scoped>
.page-export-test {
  background: #ffffff;
  padding: 30px 20px 0px;
  font-family: "PingFangSC-Medium", "PingFang SC";
}
header {
  text-align: center;
  border-bottom: 1px dotted rgba(25, 31, 37, 0.2);
  font-size: 22px;
  font-weight: 500;
  color: #111f2c;
  margin-top: 10px;
  // background: url("~@/views/pt/images/logo.png") no-repeat left top;
  // background-size: 140px;
  .header-info {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #111f2c;
    h3::after {
      content: "";
      width: 189px;
      height: 1px;
      display: inline-block;
      background: #111f2c;
      border-bottom: 1px solid #111f2c;
      margin-left: 10px;
    }
  }
}
section {
  background: url("~@/views/pt/images/watermark.png");
  background-size: 700px;
  .test-info {
    margin-top: 20px;
    border-bottom: 6px solid #f2f4f5;
    page-break-inside: avoid;
    // padding-bottom: 10px;
    .test-info__head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      font-size: 14px;
      .test-info__head__left {
        font-weight: 900;
        color: #111f2c;
      }
      .test-info__head__right {
        font-weight: 400;
        color: rgba(17, 31, 44, 0.56);
      }
    }
    .test-info__body {
      font-size: 14px;
      line-height: 30px;
    }
    .test-info__answer {
      display: flex;
      flex-wrap: wrap;
      margin-top: 5px;
      &__item {
        display: flex;
        // flex-wrap: wrap;
        padding: 0 10px;
        align-items: center;
        min-width: 180px;
        min-height: 28px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #a3a5a8;
        font-size: 14px;
        line-height: 30px;
        margin-right: 24px;
        margin-bottom: 8px;
        span {
          border-right: 1px solid #e3e4e4;
          padding-right: 16px;
          margin-right: 15px;
        }
        .item {
          display: inline-block;
        }
      }
    }
  }
}
#answer {
  .answer-content__style {
    font-size: 14px;
    font-weight: 400;
    color: #111f2c;
    margin-top: 16px;
  }
  .answer__head {
    text-align: center;
    margin-top: 34px;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: 900;
    color: #111f2c;
  }
  .answer-content {
    font-size: 14px;
    line-height: 30px;
    font-weight: 500;
    color: #111f2c;
    padding-bottom: 6px;
    border-bottom: 6px solid #f2f4f5;
    .reference-version {
      border-bottom: 1px solid rgba(17, 31, 44, 0.12);
      padding-top: 8px;
      &__title {
        font-weight: 900;
        font-size: 14px;
      }
    }
    .text-analysis {
      margin-top: 8px;
      position: relative;
      .text-analysis__head {
        margin-left: 10px;
        font-weight: 900;
        &::before {
          content: "";
          position: absolute;
          height: 14px;
          border-left: 2px solid #0089ff;
          border-radius: 1px;
          top: 3px;
          left: 0px;
        }
      }
    }
  }
}
footer {
  position: fixed;
  right: 0px;
  top: 50%;
  .stamp {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background: #1989fa;
    line-height: 80px;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    color: #ffffff;
    border: 5px solid #f2f4f5;
  }
  .go-top {
    width: 95px;
    height: 30px;
    background: #ffa82d;
    border-radius: 33px 0px 0px 33px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin-top: 36px;
  }
}
@media print {
  @page {
    margin-top: 0;
    margin-bottom: 0;
  }
  header {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    background: url("~@/views/pt/images/logo.png") no-repeat left top;
    background-size: 140px;
  }
  section {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    background: url("~@/views/pt/images/watermark.png");
    background-size: 700px;
  }
  footer {
    display: none;
  }
  h1 {
    page-break-before: always;
  }
}
</style>
